module.exports = __webpack_public_path__ + "assets/word_flow_default.bd2fc49b.svg";